'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('slick-carousel');

require('venobox');

var _Helpers = require('common/Helpers');

var _state = require('state');

var _Flow = require('components/Flow');

var _Flow2 = _interopRequireDefault(_Flow);

var _QuickView = require('../../components/QuickView');

var _QuickView2 = _interopRequireDefault(_QuickView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var productGridBuilder = function productGridBuilder() {
  var featProdCheck = $('.js-custom-lp-product-grid-entry').length;

  if (featProdCheck > 0) {
    $('.js-custom-lp-product-grid-entry').each(function (index, element) {
      var $productGridEntry = $(element);
      var featProdArray = [];

      for (var i = 0; i <= 7; i++) {
        var n = i + 1;
        var dataProductValue = $productGridEntry.data('product-' + n);

        if (dataProductValue === undefined) {
          break;
        } else if (dataProductValue === '') {
          continue;
        }
        featProdArray[i] = dataProductValue;
      }

      featProdArray = featProdArray.filter(String);

      var promises = featProdArray.map(function (handle) {
        var resource = 'products/' + handle;
        var templateName = 'ajax-grid-item';
        return (0, _Helpers.getAlternativeTemplate2)({ resource: resource, templateName: templateName }).then(function (response) {
          return $productGridEntry.append(response);
        });
      });

      Promise.all(promises).then(function () {
        _Flow2.default.localize({ force: true });
        (0, _state.initContainers)({ type: 'product' });
      });

      // for (let i = 0; i < featProdArray.length; i++) {
      //   const handle = featProdArray[i];

      //   $.get('/products/' + handle + '?view=ajax-grid-item', () => {}).done(response => {
      //     $productGridEntry.append(response);
      //     // LazyLoad.getInstance().update();
      //     QuickView.init();
      //   });
      // }
    });
  }
}; // end productGridBuilder()

var initContentEdit = function initContentEdit() {
  if ($('.js-shogun-content-entry').hasClass('custom-lp-entry-container--black')) {
    $('.button--black-gradient').removeClass('button--black-gradient').addClass('button--white-gradient');
  }
};

var videoHeroInit = function videoHeroInit() {
  var videoHeroCheck = $('.venobox').length;

  if (videoHeroCheck > 0) {
    $('.venobox').venobox();
  }
}; // end videoHeroInit()

var slideShowInit = function slideShowInit() {
  var slideshowCheck = $('.js-custom-lp-slideshow').length;
  var options = {
    dots: true,
    prevArrow: '<button type="button" class="slick-prev-arrow">{{ "left-arrow-black.svg" | asset_url | img_tag }}</button>',
    nextArrow: '<button type="button" class="slick-next-arrow">{{ "right-arrow-black.svg" | asset_url | img_tag }}</button>',
    dotsClass: 'custom-lp-slideshow-dots'
  };

  if (slideshowCheck > 0) {
    var $slideshowContainer = $('.js-custom-lp-slideshow');

    $slideshowContainer.slick(options).slick('slickFilter', '.visible');
  }
}; // end slideShowInit()

exports.default = {
  init: function init() {
    initContentEdit();
    productGridBuilder();
    videoHeroInit();
    slideShowInit();
  }
};